<script setup lang="ts">
import { AppIcon, BrandMark } from '@atum-remote/ui';
defineProps<{ error?: unknown; failed?: boolean }>();
const reload = () => location.reload();
</script>

<template>
  <main class="session-load">
    <div class="session-load-panel panel">
      <BrandMark />
      <h1>{{ failed || error ? 'The desktop viewer could not load.' : 'Loading desktop…' }}</h1>
      <p v-if="failed || error">
        The page may have changed since you opened it, or the connection was interrupted.
      </p>
      <button v-if="failed || error" type="button" class="primary" @click="reload">
        Reload viewer
      </button>
      <a href="/"><AppIcon name="back" />Back to devices</a>
    </div>
  </main>
</template>
